import { useCallback } from 'react'

export const useBannerManagement = (updateStore) => {
  const updateBanner = useCallback(
    (promoCode, channel, amount) => {
      localStorage.setItem('banner', JSON.stringify({ promoCode, channel, amount }))
      updateStore((prevState) => ({
        ...prevState,
        banner: { promoCode, channel, amount },
      }))
    },
    [updateStore]
  )

  const checkAndApplyExistingBanner = useCallback(() => {
    const existingBanner = JSON.parse(localStorage.getItem('banner'))
    if (existingBanner) {
      const { promoCode, channel, amount } = existingBanner
      updateBanner(promoCode, channel, amount)
    }
  }, [updateBanner])

  const checkUtmParamsForPromo = (searchParams) => {
    const urlParams = new URLSearchParams(searchParams)
    const promoCode = urlParams.get('promo')
    const channel = urlParams.get('channel')
    const amount = urlParams.get('amount')
    if (promoCode) updateBanner(promoCode, channel, amount)
  }

  return { updateBanner, checkUtmParamsForPromo, checkAndApplyExistingBanner }
}
